import React from 'react';

export default function TemplatePreviewCard({ preview, validation, sampleInfo = '' }) {
  return (
    <div className="bg-white dark:bg-[#151f2b] rounded-2xl border border-slate-200 dark:border-slate-800 p-4 space-y-2">
      <h2 className="text-lg font-bold text-slate-900 dark:text-white">Önizleme</h2>
      <p className="text-sm rounded-lg bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-800 p-3">
        {preview || 'Önizleme yok'}
      </p>
      <div className="text-xs text-slate-500">
        <p>Doğrulama: {validation?.valid ? 'Geçti' : 'Kaldı'}</p>
        <p>Hatalar: {(validation?.errors || []).join(', ') || '-'}</p>
        {sampleInfo ? <p className="mt-2 rounded-lg border border-amber-200 bg-amber-50 px-2 py-1 text-amber-700">{sampleInfo}</p> : null}
      </div>
    </div>
  );
}
